function getDropDownOptions(
  list,
  allSelectLabel,
  allSelectValueString,
  labelKey,
  valueKey
) {
  // Create the default option
  const defaultOption = { label: allSelectLabel, value: allSelectValueString }

  // If the list is empty or contains no values, return the array with the default 'All' option
  if (!list || list.length === 0) {
    return [{ label: 'All', value: '' }]
  }

  // Create the options from the list, ensuring no duplicate values
  const options = list
    .map((item) => ({
      label: item[labelKey],
      value: item[valueKey],
    }))
    .filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.value === item.value)
    )

  // Return the combined array
  const result =
    options.length === 1 ? [...options] : [defaultOption, ...options]
  return result
}

// Get drop down option based on what is available in the List.
function getLookupValueDropDownOption(
  list,
  fieldName,
  lookup,
  allSelectLabel,
  allSelectValueString,
  fieldCode
) {
  const defaultOption = { label: allSelectLabel, value: -1 }
  const lookupOption = list.map((item) => {
    const {
      [`${fieldName}/${lookup}`]: lookupLable,
      [fieldCode]: lookupValue,
    } = item
    return { label: lookupLable, value: lookupValue }
  })
  const filteredLookupOption = lookupOption.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.value === item.value)
  )
  const result =
    filteredLookupOption.length === 1
      ? [...filteredLookupOption]
      : [defaultOption, ...filteredLookupOption]

  return result
}
export { getDropDownOptions, getLookupValueDropDownOption }
